module.exports = __webpack_public_path__ + "files/900cd879e10a452183a107527169176b.png";